import { createSelector } from "reselect";
const selector = (state) => state.apps;

export default createSelector([selector], (data) => data);